import './WhySection.css';

const metrics = [
  { value: '99.9%', label: 'Payout success rate with multi-bank failover' },
  { value: '< 60s', label: 'Typical payout latency, request to credit' },
  { value: '2-4 wk', label: 'From the kickoff call to your first live payout' },
];

export default function WhySection() {
  return (
    <section className="why">
      <div
        className="why__bg"
        style={{ backgroundImage: 'url(/why-bg.png)' }}
      />
      <div className="why__container">
        <div className="why__left">
          <p className="why__eyebrow">Why settlor.money</p>
          <h2 className="why__heading">One payout rail your finance and engineering teams can <span className="why__heading--accent">both trust.</span></h2>
          <p className="why__body">Most teams run payouts through a patchwork of bank portals, spreadsheets and scripts that nobody fully owns. settlor.money replaces all of it with one platform for payouts, a double-entry ledger and reconciliation that closes every day.</p>
          <p className="why__body">Every payout is idempotent, every webhook is signed, and every number traces back to a transaction. The result is infrastructure your auditors accept and your engineers do not have to babysit.</p>
        </div>
        <div className="why__right">
          {metrics.map((m, i) => (
            <div key={i} className="why__metric">
              <p className="why__metric-value">{m.value}</p>
              <p className="why__metric-label">{m.label}</p>
            </div>
          ))}
          <a href="#about" className="why__link">
            See how
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M3.125 7.5H11.875" stroke="#0C1322" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7.5 3.125L11.875 7.5L7.5 11.875" stroke="#0C1322" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
